import cloneDeep from 'lodash.clonedeep';

import baseView from '../../base-view';
import template from './template.hbs';
import util from '../../utils';

const baseViewFn = baseView.make();
const modal = baseView.make();

modal.container = document.body;
modal.template = template;

modal.show = function() {
  if (!this.isRendered()) {
    return Promise.reject(new Error('View must be rendered'));
  }

  const overlay = () => {
    this.el.classList.add('overlay');
  };

  const expand = () => {
    const transition = util.waitForTransition(this.el);

    this.el.classList.add('visible');
    document.body.classList.add('modal-open');

    return transition;
  };

  return util.animate(overlay)
    .then(() => util.animate(expand));
};

modal.hide = function() {
  if (!this.isRendered()) {
    return Promise.reject(new Error('View must be rendered'));
  }

  const hideModal = () => {
    this.el.classList.remove('overlay');
    document.body.classList.remove('modal-open');
  };

  const transition = util.waitForTransition(this.el)
    .then(hideModal);

  this.el.classList.remove('visible');

  return transition;
};

modal.render = function(container) {
  const addListeners = () => {
    const closeButton = this.el.querySelector('.close');

    if (closeButton) {
      closeButton.addEventListener('click', () => this.close());
    }
  };

  return baseViewFn.render.call(this)
    .then(addListeners);
};

const make = cloneDeep.bind(null, modal);

export default {
  make,
};
